export class TableAttributeFilter {
    
    public TableName?: string;
}

export default TableAttributeFilter;